import { type MiddlewareFunction } from 'react-router';
import { tokenProviderContext } from '@/request-context.ts';
import { getAuthorizedData } from '@/routes-utils/handle-authorized-data.ts';
import { sessionContext, sessionFromTokens } from '@/session.ts';

export const appSessionMiddleware: MiddlewareFunction = async (
  { context },
  next,
) => {
  const tokens = await context.get(tokenProviderContext).getTokens();
  context.set(sessionContext, sessionFromTokens(tokens));
  return next();
};

export const appSessionClientMiddleware: MiddlewareFunction = async (
  { context },
  next,
) => {
  const { tokens } = await getAuthorizedData();
  context.set(sessionContext, sessionFromTokens(tokens));
  return next();
};
